import { render, staticRenderFns } from "./CampaignDropdown.vue?vue&type=template&id=a800b540&scoped=true&"
import script from "./CampaignDropdown.vue?vue&type=script&lang=js&"
export * from "./CampaignDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDropdown.vue?vue&type=style&index=0&id=a800b540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a800b540",
  null
  
)

export default component.exports